/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable react/no-array-index-key */
import { Occupant } from '@acp/shared';
import { Box, Text } from '@chakra-ui/react';
import { faAt, faPhone } from '@fortawesome/pro-solid-svg-icons';
import { FaIcon } from '../fa-icon';

export function OccupantContacts({
    occupants,
}: {
    occupants: Occupant[];
}) {
    return (
        <>
            {occupants.map((occupant: Occupant, idx: number) => (
                <Box key={`occupant-${idx}`}>
                    <Text fontSize="small" fontWeight="bold">
                        {occupant?.name}
                    </Text>
                    {occupant?.mobileContacts?.filter((contact: string) => contact.trim() !== '')
                        .map((contact: string, contactIdx: number) => (
                            <Text fontSize="small" key={`contact-${contactIdx}`}>
                                <FaIcon color="muted.200" icon={faPhone} mr={1} />
                                {contact}
                            </Text>
                        ))}
                    {occupant?.email && (
                        <Text fontSize="small">
                            <FaIcon color="muted.200" icon={faAt} mr={1} />
                            {occupant?.email}
                        </Text>
                    )}
                </Box>
            ))}
        </>
    );
}
